export class TrackInfo{

  public path: string[];
  public pageId: string;
  public action: any;
  public parameters: any;

  constructor(pageId: string, path: string[], action?: any, parameters?: any) {
    this.pageId = pageId;
    this.path = path;
    this.action = action;
    this.parameters = parameters;
  }

}
